module.exports = __webpack_public_path__ + "img/37_142.be6ba371.png";